import { render, staticRenderFns } from "./ModalSelecionaMatricula.vue?vue&type=template&id=71937c56"
import script from "./ModalSelecionaMatricula.vue?vue&type=script&lang=js"
export * from "./ModalSelecionaMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports